import React, { memo } from 'react';
import { UserIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import {
  ResultWrapper,
  StyledAxonOfficerName,
  StyledAxonBadgeNumber,
} from '../ConnectedUniversalSearch.styles';

const StyledAxon = memo(
  ({ axon, index, mouseCursor, maxWidth, handleAxonSearchResult }) => {
    const lastName = axon?._lastName || '';
    const firstName = axon?.attributes?.officer?.first_name || '';
    const badgeNumber = axon?._badgeNumber || '';
    const coordinates =
      axon?.shape?.features?.[0]?.geometry?.coordinates || undefined;

    return (
      <ResultWrapper
        key={index}
        isHovered={mouseCursor === index}
        maxWidth={maxWidth}
        onClick={() => handleAxonSearchResult({ coordinates, axon })}
      >
        <Box horizontal p="0" m="0">
          <UserIcon width={16} height={16} />
          <Box p="0" m="0">
            <StyledAxonOfficerName>
              {lastName}, {firstName ? firstName[0] : ''}
            </StyledAxonOfficerName>
            {badgeNumber && (
              <Box horizontal>
                <StyledAxonBadgeNumber>{badgeNumber}</StyledAxonBadgeNumber>
              </Box>
            )}
          </Box>
        </Box>
      </ResultWrapper>
    );
  },
);

export default StyledAxon;
